import React, { useEffect, useState } from "react";
import logo from "../asset/logo.png";
import logowhite from "../asset/logowhite.png";

const SplashScreen = ({ onFinish }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Get theme from localStorage only
    const savedTheme = localStorage.getItem("theme");
    const shouldBeDark = savedTheme === "dark";
    setIsDark(shouldBeDark);
  }, []);

  useEffect(() => {
    // Increment progress
    const interval = setInterval(() => {
      setProgress((prev) => {
         const nextProgress = prev +(1); 
        if (nextProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return nextProgress + 1;
      });
    }, 40);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // When progress reaches 100%, finish splash
    if (progress >= 100) {
      const timeout = setTimeout(() => {
        setIsVisible(false);
        if (onFinish) onFinish();
      }, 100); // Slight delay for smooth transition, adjust as needed
      return () => clearTimeout(timeout);
    }
  }, [progress, onFinish]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-white dark:bg-[#0b0f1a] flex flex-col items-center justify-center z-50 px-6">
      <img src={isDark ? logowhite : logo} alt="Logo" className="mb-6 transition duration-300" />

      {/* Progress Bar Container */}
       <div className="w-full max-w-md h-3 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden shadow-inner">
        <div
          className="h-full transition-all duration-300"
          style={{
            width: `${progress}%`,
            background: isDark
              ? "#ffffff"
              : "linear-gradient(90deg, #1C3C78, #2E58A6)",
          }}
        />
      </div>

      {/* Percentage Text */}
<p className="mt-3 font-semibold text-lg text-[#1C3664] dark:text-white">
  {progress}%
</p>

    </div>
  );
};

export default SplashScreen;